import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import {
  GavelOutlined,
  AccountCircleOutlined,
  GroupsOutlined,
  PaymentsOutlined,
  SchoolOutlined,
  BlockOutlined,
  CopyrightOutlined,
  SecurityOutlined,
  UpdateOutlined,
  PersonOutlineOutlined,
} from "@mui/icons-material";
import Footer from "./Footer";

const TermsCondition=()=> {
  const sections = [
    {
      icon: <GavelOutlined fontSize="large" color="primary" />,
      title: "Terms of Use",
      content:
        "By accessing or using PriceWorth.com, you acknowledge that you have read, understood, and agree to comply with these Terms and Conditions. These terms govern your access to the platform, participation in buying groups, and use of our services. If you do not agree with any part of these terms, you should discontinue using the platform.",
    },
    {
      icon: <PersonOutlineOutlined fontSize="large" color="success" />,
      title: "Eligibility",
      content:
        "Users must be at least 18 years of age to create an account and use PriceWorth independently. Individuals under the age of 18 may access the platform only with the supervision and consent of a parent or legal guardian. By registering, you confirm that the information you provide is accurate and that you meet the eligibility requirements.",
    },
    {
      icon: <AccountCircleOutlined fontSize="large" color="info" />,
      title: "User Accounts",
      content:
        "Creating an account allows you to participate in buying groups and access PriceWorth services. You are responsible for maintaining accurate account information, protecting your password, and ensuring that all activities performed through your account comply with these Terms.",
      list: [
        "Maintain accurate personal information.",
        "Keep your password confidential.",
        "Notify us immediately if you suspect unauthorized access.",
        "Accept responsibility for all activity under your account.",
      ],
    },
    {
      icon: <GroupsOutlined fontSize="large" color="warning" />,
      title: "Buying Groups",
      content:
        "PriceWorth organizes buying groups to negotiate better pricing with institutes and service providers. Participation in a buying group does not guarantee a successful negotiation or a specific discount. Final pricing depends on multiple business factors.",
      list: [
        "Number of participants in the group.",
        "Participation of institutes or providers.",
        "Current market conditions.",
        "Availability of promotional offers.",
      ],
    },
    {
      icon: <PaymentsOutlined fontSize="large" color="success" />,
      title: "Payments",
      content:
        "Payments must be completed using the approved payment methods available on the platform. Unless otherwise stated, displayed prices include applicable taxes. Users should verify payment details before completing any transaction.",
    },
    {
      icon: <SchoolOutlined fontSize="large" color="primary" />,
      title: "Institute Selection",
      content:
        "PriceWorth negotiates with multiple educational institutes and training providers to obtain competitive offers. However, PriceWorth does not guarantee admission, certification, course completion, or employment outcomes. The final enrollment agreement exists between the user and the selected institute unless explicitly stated otherwise.",
    },
    {
      icon: <BlockOutlined fontSize="large" color="error" />,
      title: "Prohibited Activities",
      content:
        "To maintain a safe and trustworthy platform, users must not engage in activities that disrupt services or violate applicable laws.",
      list: [
        "Submitting false or misleading information.",
        "Attempting unauthorized access.",
        "Misusing the platform or its services.",
        "Interfering with negotiations.",
        "Violating applicable laws or regulations.",
      ],
    },
    {
      icon: <CopyrightOutlined fontSize="large" color="secondary" />,
      title: "Intellectual Property",
      content:
        "All content available on PriceWorth, including logos, text, graphics, software, trademarks, and branding, is owned by PriceWorth or its respective licensors. Users may not copy, reproduce, distribute, or modify this content without prior written permission.",
    },
    {
      icon: <SecurityOutlined fontSize="large" color="warning" />,
      title: "Limitation of Liability",
      content:
        "PriceWorth provides its platform and services on a best-effort basis. We are not responsible for indirect, incidental, or consequential losses arising from the use of the platform, including delays, unsuccessful negotiations, or third-party actions beyond our control.",
    },
    {
      icon: <UpdateOutlined fontSize="large" color="info" />,
      title: "Changes to These Terms",
      content:
        "PriceWorth may update these Terms and Conditions periodically to reflect legal, technical, or business changes. Continued use of the platform after updates are published constitutes acceptance of the revised Terms.",
    },
  ];

  return (
    <>
    <div
      style={{
        background: "#f8fafc",
        minHeight: "100vh",
        padding: "50px 0",
      }}
    >
      <Container>
        {/* Hero Section */}
        <div
          style={{
            background:
              "linear-gradient(135deg,#1e3a8a,#2563eb,#3b82f6)",
            borderRadius: 25,
            padding: "60px 30px",
            textAlign: "center",
            color: "#fff",
            marginBottom: 40,
            boxShadow: "0 20px 45px rgba(37,99,235,.25)",
          }}
        >
          <GavelOutlined style={{ fontSize: 70 }} />

          <h1
            style={{
              marginTop: 20,
              fontWeight: 700,
            }}
          >
            Terms & Conditions
          </h1>

          <p
            style={{
              maxWidth: 850,
              margin: "20px auto",
              lineHeight: 1.8,
              color: "#dbeafe",
            }}
          >
            These Terms & Conditions explain the rules, responsibilities,
            and conditions for using the PriceWorth platform. Please read
            them carefully before creating an account, joining buying
            groups, or purchasing any services.
          </p>
        </div>

        <Row>
          {sections.map((section, index) => (
            <Col lg="6" className="mb-4" key={index}>
              <Card
                style={{
                  border: "none",
                  borderRadius: 20,
                  boxShadow: "0 10px 25px rgba(0,0,0,.08)",
                  height: "100%",
                }}
              >
                <CardBody style={{ padding: 30 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 20,
                    }}
                  >
                    <div
                      style={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        background: "#eff6ff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 18,
                      }}
                    >
                      {section.icon}
                    </div>

                    <h4
                      style={{
                        margin: 0,
                        fontWeight: 700,
                        color: "#1e293b",
                      }}
                    >
                      {section.title}
                    </h4>
                  </div>

                  <p
                    style={{
                      lineHeight: 1.9,
                      color: "#475569",
                      textAlign: "justify",
                    }}
                  >
                    {section.content}
                  </p>

                  {section.list && (
                    <ul
                      style={{
                        lineHeight: 2,
                        color: "#334155",
                        paddingLeft: 20,
                      }}
                    >
                      {section.list.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Footer Notice */}
        <Card
          style={{
            marginTop: 25,
            border: "none",
            borderRadius: 20,
            background: "#e0f2fe",
            boxShadow: "0 10px 20px rgba(0,0,0,.08)",
          }}
        >
          <CardBody className="text-center p-4">
            <h4
              style={{
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              Acceptance of Terms
            </h4>

            <p
              style={{
                marginBottom: 0,
                lineHeight: 1.8,
                color: "#334155",
              }}
            >
              By continuing to use PriceWorth, you acknowledge that you
              have read, understood, and agreed to these Terms &
              Conditions. If you do not agree, please discontinue using
              the platform.
            </p>
          </CardBody>
        </Card>
      </Container>
    </div>

    <Footer />
    </>
    
  );
}

export default TermsCondition;